module.exports = __webpack_public_path__ + "img/about-us.175f3e6.jpg";